import styled from 'styled-components';
import { Button } from '@lux/buttons';
export const StyledVoucherBanner = styled.div `
    width: 100%;
    background-color: ${props => props.color || props.theme.complementaryColor.vivid20};
    padding: 8px 12px 8px 8px;
    box-sizing: border-box;
    border-radius: 4px;
`;
export const IconWrapper = styled.div `
    & svg {
        width: 40px;
        height: 40px;
    }
`;
export const InfoWrapper = styled.div `
    display: flex;
    align-items: flex-start;
`;
export const TextWrapper = styled.div `
    flex-grow: 1;
    margin-left: 8px;
    align-self: center;
`;
export const DescriptionText = styled.div `
    text-align: left;
`;
export const CloseButton = styled.button `
    margin-left: 4px;
    padding: 0;
    outline: none;
    border: none;
    cursor: pointer;
    background-color: transparent;
`;
export const DescriptionButton = styled(Button) `
    margin-right: -24px;
`;
export const ButtonWrapper = styled.div `
    display: flex;
    justify-content: flex-end;
`;
export const TextButtonWrapper = styled.div `
    margin-top: 0px;
`;
//# sourceMappingURL=styles.js.map